import i18n from '@/i18n';

export default [
  { id: '1', title: i18n.global.t('specialty.vocals') }
];
